import { Amount } from '../../deals/redux/types';

const ReferralsTypes = {
    GET_REFERRALS_REQ: 'GET_REFERRALS_REQ',
    SET_REFERRALS: 'SET_REFERRALS',
};

export default ReferralsTypes;

export interface Referrals {
    uuid: string;
    referrerUUID: string;
    refereeUUID: string;
    expireAt: string;
    successInvestmentUUID?: string;
    fee?: Amount;
    status: string;
    creationAudit: {
        updatedAt: string;
        updatedBy: string;
        event: string;
    };
    updateAudit: {
        updatedAt: string;
        updatedBy: string;
        event: string;
    };
    referrerUser: {
        name: string;
        email: string;
        investorStatus: string;
        creationAudit?: {
            updatedAt: string;
            updatedBy: string;
            event: string;
        };
    };
    refereeUser: {
        creationAudit: { updatedAt: string; updatedBy: string; event: string; };
        email: string;
        investorStatus: string;
        name: string;
    }
}

export interface ReferralData {
    totalFeePaid: Amount;
    referrals: {
        uuid: string;
        referrerUUID: string;
        refereeUUID: string;
        expireAt: string;
        successInvestmentUUID?: string;
        fee?: Amount;
        status: string;
        creationAudit: {
            updatedAt: string;
            updatedBy: string;
            event: string;
        };
        updateAudit: {
            updatedAt: string;
            updatedBy: string;
            event: string;
        };
        referrerUser: {
            name: string;
            email: string;
            investorStatus: string;
            creationAudit?: {
                updatedAt: string;
                updatedBy: string;
                event: string;
            };
        };
        refereeUser: {
            creationAudit: { updatedAt: string; updatedBy: string; event: string; };
            email: string;
            investorStatus: string;
            name: string;
        }
    }[];
    referredCount: number;
    successfulCount: number;
}

export interface ReferralState {
    referrals: ReferralData | undefined;
    loading: boolean;
}
